import * as React from 'react';
import { getLocalSettings } from 'components/settings/localStore';
import logger from 'lib/logger';
import { ErrorLayout } from './ErrorLayout';

interface ErrorBoundaryProps {
    children: React.ReactNode;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps> {
    state = {
        hasError: false
    };

    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        logger.critical('componentDidCatch', { error, info });
    }

    handleClick = () => {
        this.setState({ hasError: false });
    };

    render() {
        if (this.state.hasError) {
            // TODO: Custom UI for unhandled errors
            const merchantId = getLocalSettings()?.merchantId;
            const fallbackUrl = `/${merchantId ?? ''}`;
            return (
                <ErrorLayout
                    title="Something went wrong"
                    fallbackTitle="Home"
                    fallbackUrl={fallbackUrl}
                    onClick={this.handleClick}
                />
            );
        }
        // No errors were thrown
        return this.props.children;
    }
}
